import React from 'react';
import { Route } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import AssignPropertyManagersContainer from './containers/assign-property-managers/assign-property-managers.container';

export const PropertyManagersModule = () => (
  <Route
    exact
    path={APP_ROUTES.OPERATION_MODULE.CHILDREN?.PROPERTY_MANAGERS.PATH}
    component={AssignPropertyManagersContainer}
  />
);
